<!-- @format -->

<div class="row" data-cy="open-university-enrolment-right">
  @if (editInfos?.length > 0) {
    <div class="col-12 sis-mb-md">
      <sis-contextual-notification variant="warning" data-cy="enrolment-right-edit-info">
        {{ "OPENUNIVERSITY.STUDY_RIGHTS.ENROLMENT_RIGHT.EDITED" | translate }}
        <sis-button [link]="true" (clicked)="openEditInfoDialog()">
          {{ "OPENUNIVERSITY.STUDY_RIGHTS.ENROLMENT_RIGHT.SHOW_EDIT_RATIONALE" | translate }}
        </sis-button>
      </sis-contextual-notification>
    </div>
  }
  @if (cancellationInfo) {
    <div class="col-12 sis-mb-md">
      <sis-contextual-notification variant="warning" data-cy="enrolment-right-cancellation-info">
        {{
          "OPENUNIVERSITY.STUDY_RIGHTS.ENROLMENT_RIGHT.CANCELLED" | translate: { date: cancellationInfo.modificationTime | localDateFormat }
        }}
        <sis-button [link]="true" (clicked)="openCancellationInfoDialog()">
          {{ "OPENUNIVERSITY.STUDY_RIGHTS.ENROLMENT_RIGHT.SHOW_CANCELLATION_RATIONALE" | translate }}
        </sis-button>
      </sis-contextual-notification>
    </div>
  }
  <div class="col-12 col-sm-6 col-lg-5 sis-mb-sm">
    <sis-description-list-compact>
      <dl>
        @if (enrolmentRight?.courseUnitId | courseUnit | async; as courseUnit) {
          <ng-template #compactListItem>
            <dt class="sis-label colon">{{ "OPENUNIVERSITY.STUDY_RIGHTS.ENROLMENT_RIGHT.COURSE_UNIT_CODE" | translate }}</dt>
            <dd class="sis-value">
              @if (componentType === "STAFF" && curriculumPeriod$ | async; as curriculumPeriod) {
                <a href="/staff/studies/staff/{{ curriculumPeriod.id }}/courseunit/{{ courseUnit.id }}/basicinfo">{{ courseUnit.code }} </a>
              }
              @if (componentType === "STUDENT") {
                <a href="/student/courseunit/{{ courseUnit.id }}">{{ courseUnit.code }}</a>
              }
            </dd>
          </ng-template>
        }
        @if (formattedCredits$ | async; as formattedCredits) {
          <ng-template #compactListItem>
            <dt class="sis-label colon">{{ "OPENUNIVERSITY.STUDY_RIGHTS.ENROLMENT_RIGHT.SCOPE" | translate }}</dt>
            <dd class="sis-value">
              {{ formattedCredits }}
            </dd>
          </ng-template>
        }
        <ng-template #compactListItem>
          <dt class="sis-label colon">{{ "OPENUNIVERSITY.STUDY_RIGHTS.ENROLMENT_RIGHT.VALIDITY_PERIOD" | translate }}</dt>
          <dd class="sis-value">{{ enrolmentRight.validityPeriod | localDateRange }}</dd>
        </ng-template>
        @if (isCurEnrolmentRight) {
          <ng-template #compactListItem>
            <dt class="sis-label colon">{{ "OPENUNIVERSITY.STUDY_RIGHTS.ENROLMENT_RIGHT.GRANTED_BY_PRODUCT" | translate }}</dt>
            @if (openUniversityProduct$ | async; as openUniversityProduct) {
              <dd class="sis-value">
                @if (componentType === "STAFF" && curriculumPeriod$ | async; as curriculumPeriod) {
                  <a
                    href="/staff/studies/staff/{{ curriculumPeriod.id }}/courseunit/{{
                      enrolmentRight?.courseUnitId
                    }}/openuniversity-studyoffers/{{ enrolmentRight?.courseUnitId }}/view-product/{{ openUniversityProduct.id }}/info"
                    >{{ openUniversityProduct.name | localizedString }}</a
                  >
                }
                @if (componentType === "STUDENT") {
                  <ng-container>{{ openUniversityProduct.name | localizedString }}</ng-container>
                }
              </dd>
            }
          </ng-template>
        }
      </dl>
    </sis-description-list-compact>
  </div>
  @if (isCurEnrolmentRight) {
    <div class="col-12 col-sm-6 col-lg-7">
      @if (courseUnitRealisationsByAssessmentItemId$ | async; as courseUnitRealisationsByAssessmentItemId) {
        <ng-container>
          @if (showInfoTextByAssessmentItemId$ | async; as showInfoTextByAssessmentItemId) {
            <ng-container>
              @if (remainingEnrolmentCountsByAssessmentItemId$ | async; as remainingEnrolmentCountsByAssessmentItemId) {
                <ng-container>
                  <sis-description-list [columnCount]="1">
                    <dl>
                      @for (assessmentItem of assessmentItems$ | async; track assessmentItem) {
                        <ng-template #listItem>
                          <dt class="sis-label">
                            {{ assessmentItem.name | localizedString }} ({{ assessmentItem.credits | creditRange }})
                          </dt>
                          <dd>
                            <sis-open-university-assessment-item
                              [courseUnitRealisations]="courseUnitRealisationsByAssessmentItemId[assessmentItem.id] || []"
                              [showCourseUnitRealisationInfoText]="showInfoTextByAssessmentItemId[assessmentItem.id]"
                              [remainingEnrolmentCounts]="remainingEnrolmentCountsByAssessmentItemId[assessmentItem.id]"
                              [componentType]="componentType">
                            </sis-open-university-assessment-item>
                          </dd>
                        </ng-template>
                      }
                    </dl>
                  </sis-description-list>
                </ng-container>
              }
            </ng-container>
          }
        </ng-container>
      }
    </div>
  }
</div>
